import React from "react";
import "./FlowOptimizationContent.css";

// Importa tus imágenes aquí
import researchImg1 from "../../../assets/projects/FlowOptimization/Flow-Optimization-4.png";
import researchImg2 from "../../../assets/projects/FlowOptimization/Flow-Optimization-3.JPEG";
import IconFlowText from "../../../assets/projects/FlowOptimization/Flow-Optimization-IconText.png";
import ilustration_two from "../../../assets/projects/FlowOptimization/ILUSTRACION22.png";
// Agrega las nuevas imágenes que necesites
import journeyImg from "../../../assets/projects/FlowOptimization/journey.png";
import workshopImg from "../../../assets/projects/FlowOptimization/workshop.png";
import serviceBlueprint from "../../../assets/projects/FlowOptimization/service-blueprint.png";
import ilustrationIssues from "../../../assets/projects/FlowOptimization/ilustracion-issues.png";
import mockupGalleryOne from "../../../assets/projects/FlowOptimization/mockup1.png";
import mockupGalleryTwo from "../../../assets/projects/FlowOptimization/mockup2.png";

import Information from "../../../assets/projects/FlowOptimization/file-contract_icon.png";
import Transparency from "../../../assets/projects/FlowOptimization/transparencyIcon.png";
import database from "../../../assets/projects/FlowOptimization/database.png";

export default function FlowOptimizationContent() {
  return (
    <div className="flow-content">
      {/* Intro Quote */}
      <div className="flow-intro">
        <p>
          This was a cross-functional project developed in collaboration with
          product, engineering and business team at <strong>BBVA</strong>.
        </p>
      </div>

      {/* Main Question */}
      <h1 className="flow-question">
        How can we make the journey of the account managers easier when
        delivering a product?
      </h1>

      {/* Description */}
      <div className="flow-description">
        <p>
          Account Executives used more than{" "}
          <span className="highlight-purple">11 different applications</span>{" "}
          during product procurement process. The business vision was that by
          reducing this number, executives can have a streamlined flow and
          reduce time going by changing through different applications. The
          efficiency would ultimately satisfy expectations from one commitment,
          lower costs.
        </p>
      </div>

      {/* Highlight Box with Research Image */}
      <div className="flow-highlight-with-image">
        <div className="flow-highlight-box">
          <span className="flow-highlight-number">+ 3000</span>
          <p className="flow-highlight-text">
            It was thought that… Account Executives used more than 11 different applications during the product procurement process. The business vision was that by reducing this number, Account Executives could work through a more streamlined flow decreasing the time spent switching between tools. This efficiency would ultimately reduce operational time and, consequently, lower costs.
          </p>
        </div>

        <div className="flow-research-section">
          <img src={researchImg1} alt="Research process" />
          <div className="flow-research-content">
            <p>
              <strong>
                To know at first-hand the actual situation and validate the main
                hypothesis,
              </strong>{" "}
              I planned and conducted <u>12 interviews</u> with account managers
              from different divisions and other involved roles to map:
            </p>
            <ul>
              <li>Who is the user?</li>
              <li>What are their goals?</li>
              <li>How does the current product contracting process work?
</li>
              <li>How they interact with other involved roles?</li>
              <li>Which tools and applications do they use?
</li>
              <li>Why is important for them to use them?</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Mapping the findings */}
      <section className="flow-section">
        <h2 className="flow-section-title">Mapping the findings</h2>

        <div className="flow-intro">
          <p>
            <em>
     It is essential to me that the entire team is aligned around a shared understanding and empathy for our users. This ensures that everyone moves in the same direction, focusing on delivering real value to the user.
            </em>
          </p>
        </div>
    <div className="flow-description" >
        <p >

          I created a report summarizing the key insights from the interviews to share them with the team. This included the   <span className="highlight-yellow">user persona and the Account Executive’s journey map </span>, which helped clearly illustrate who our user is, their tasks, frustrations, needs, and goals. By presenting this information, the team could make more   <span className="highlight-yellow">informed decisions </span> while    <span className="highlight-yellow">keeping the user at the center of the process.</span>
      
         
        </p>
        </div>
      </section>

      {/* Who is the user */}
      <section className="flow-section">
        <h3 className="flow-subsection-title">Who is the user?</h3>

        <div className="flow-text">
          <p>
            The account executive is the face of the bank to the client and
            their closest point of contact. Providing the account manager with
            clear and timely information about the process will allow them to
            deliver timely information to the client.
          </p>
        </div>

        <div className="flow-user-cards">
          <div className="flow-user-card">
            <div className="user-card-header">
              <span className="user-label">Goals</span>
            </div>
            <ul>
              <li>Prospect for new clients.</li>
              <li>Achieve the monthly sales targets.</li>
              <li>A constant clients follow up.</li>
              <li>Build a long-term relation with the client based in confidence.</li>
              <li>Ensure a good client experience.</li>
            </ul>
          </div>

          <div className="flow-user-card illustration">
            <img src={ilustration_two} alt="User illustration" />
          </div>

          <div className="flow-user-card">
            <div className="user-card-header">
              <span className="user-label">Frustrations</span>
            </div>
            <ul>
              <li>Depending on other areas to move forward in the process.</li>
              <li>Experiencing delays that are not informed.</li>
              <li>A lack of understanding about the urgency of client requests.</li>
              <li>Entering the same information multiple times across different tools.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Journey Section */}
      <section className="flow-section">
        <h3 className="flow-subsection-title">
          What is their journey? How does they feel in every stage of the actual
          process? What are their pain points?
        </h3>

<div className="flow-description">
        <p >
          I created a journey map to represent each stage of the Account Executives workflow, allowing us to gain a broader view of the opportunities to address their pain points.
        </p>
        </div>

        <div className="flow-journey-image">
          {<img src={journeyImg} alt="User journey map" />}
          <div className="image-placeholder">Journey Map Image</div>
        </div>
      </section>

      {/* Service Blueprint Section */}
      <section className="flow-section">
        <h3 className="flow-subsection-title">
          A big change required a detail analysis
        </h3>
    <div className="flow-description">

  
        <p >
          Given the complexity of the solution, our team decided to narrow the scope to deposit-taking products. To support this focus, I
          developed a{" "}
          <span className="highlight-yellow">Service Blueprint</span> to help
          the team understand how our user interacts with other roles, which tools or applications they use at each step, and what information they need. This also allowed us to identify pain points and opportunities. Having this comprehensive view enabled us to make decisions that would not only benefit our primary user but also
          {" "}
          <span className="highlight-yellow">
            {" "}
            support the needs of the other involved areas{" "}
          </span>
        </p>
  </div>
        <div className="flow-blueprint-image">
          <img src={serviceBlueprint} alt="Service Blueprint" />
          <div className="image-placeholder">Service Blueprint Image</div>
        </div>
      </section>

      {/* Applications Question */}
      <section className="flow-section">
        <h2 className="flow-section-title">
          Account Executives used more than 11 different applications as was
          though at the beginning?
        </h2>

        <div className="flow-answer-box">
          <p>
            <strong>Not really.</strong>
          </p>
          <p>
            They actually used 7 applications, which are divided depending on the type of product being discussed: 3 for deposit-taking products and 4 for credit products. The remaining applications are used by other people involved in the process. This changed completed what we though.
          </p>
        </div>
      </section>

      {/* Issues Section */}
      <section className="flow-section">
        <h3 className="flow-subsection-title">
          Although the number of applications was not very high, there were
          serious issues behind then...
        </h3>

        <div className="flow-issues-section">
          <div className="flow-issues-section-image">
            <img src={ilustrationIssues} alt="" />
          </div>
          <div className="flow-issues-grid">
            <div className="flow-issue-card purple">
              <h3>Non-informed delays</h3>
              <p>
                Faced with delays from other departments in responding to customer requests, executives access some extra applications to find solutions on their own.
              </p>
            </div>
            <div className="flow-issue-card purple">
              <h3>Inefficiency</h3>
              <p>
              A new product contracting application was recently launched, but since then the process has slowed, from two weeks to two months.
              </p>
            </div>
            <div className="flow-issue-card purple">
              <h3>No uniformity</h3>
              <p>
                There is no unified workflow, and the applications vary by product and segment, which increases the number of tools executives must consult.
              </p>
            </div>
            <div className="flow-issue-card purple">
              <h3>No user-centered</h3>
              <p>
               The actual workflow is not agile, so each executive ends up developing their own way of working, using informal workarounds to move faster.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Proposal */}
      <section className="flow-section">
        <h2 className="flow-section-title purple-bg">Proposal</h2>

        <div className="flow-text">
          <p>
            A unified end-to-end workflow for contracting products in
            Salesforce, the primary customer relationship tool used by Corporate
            Account Executives. This solution gives them access to all key
            information from start to finish.
          </p>
        </div>

        <div className="flow-intro">
          <p>
            <em>
              I wanted to make sure that the proposal truly delivers value to
              users and that I can detect any alerts or impediments early on.
            </em>
          </p>
        </div>
      </section>

      {/* Workshop Section */}
      <section className="flow-section">
        <h3 className="flow-subsection-title">
          Workshop with users and other areas
        </h3>
        <div className="flow-research-section">
       
            <div className="flow-workshop-image">
              <img src={workshopImg} alt="Workshop" />
            </div>

            <div className="flow-workshop-text">
              <p>
                So I planned and executed remotely two separate workshops, one
                with our main users so that they feel comfortable and safe to
                honestly say what they think, and a second workshop with leaders
                of every department involved to identify any alerts in time and
                obtain approvals.
              </p>
              <ul>
                <li>What do they think about our purpose?</li>
                <li>What should we consider when creating this new workflow?</li>
                <li>What risks or warnings should I keep in mind when designing this process?</li>
                <li>How do they feel when thinking about this new process? </li>
              </ul>
            </div>
           
  
        
        </div>
      </section>

      {/* Mockups Section */}
      <section className="flow-section">
        <h2 className="flow-section-title">
          I crafted initial ideas and designed mockups grounded in the
          previously identified insights...
        </h2>

        <div className="flow-mockups-gallery">
          <img src={mockupGalleryOne} alt="" />
          <div className="image-placeholder large">Image filled with dummy data to maintain privacy.</div>
          <img src={mockupGalleryTwo} alt="" />
          <div className="image-placeholder large">Image filled with dummy data to maintain privacy.</div>
        </div>
      </section>

      {/* Benefits - Blue Section */}
      <section className="flow-blue-section">
        <h2 className="flow-blue-title">
          In this way corporate Account Executives will have...
        </h2>

        <div className="flow-blue-cards">
          <div className="flow-blue-card">
            <div className="blue-card-icon">
              <img src={Information} alt="InformationIcon"></img>
            </div>
            <h3>All in one</h3>
            <p>
              A single functionality to view, manage, and contract any type of product from start to finish.
            </p>
          </div>
          <div className="flow-blue-card">
            <div className="blue-card-icon">
              {" "}
              <img src={Transparency} alt="transparencyIcon"></img>
            </div>
            <h3>Transparency</h3>
            <p>The user will be able to see the progress of their processes, know what, who, where, when.</p>
          </div>
          <div className="flow-blue-card">
            <div className="blue-card-icon">
              <img src={database} alt="transparencyIcon"></img>
            </div>
            <h3>Data to improve</h3>
            <p>Having a complete workflow in the tool allows the creation of dashboards for monitoring and reporting.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
